import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/payment-actions.module.scss';
import { IPayment } from 'src/types/payment';
import DeletePaymentAction from './DeletePaymentAction';

const PaymentActionsColumn: React.FunctionComponent<CellProps<IPayment>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IPayment>) => {
    return (
        <div className={classNames(styles.actions)}>
            <Link className="btn btn-info" to={Router.generate(routes.PAYMENT_EDIT, { id: original.id })}>
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <DeletePaymentAction data={original} />
        </div>
    );
};

export default PaymentActionsColumn;
